import { Flex } from '@chakra-ui/react';
import Card from 'components/card/Card';
import FormCadastrarEditarHierarquia from 'components/forms/FormCadastrarEditarHierarquia';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { useContext, useEffect, useMemo, useState } from 'react';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

export default function CadastrarHierarquia() {
	const { setters } = useContext(SidebarHelpContext);
	const { setDataSidebar } = setters;

	const [formInitialState] = useState<any>({
		mercado: '',
		canal_venda: '',
		forca_venda: '',
		zona_venda: '',
		membro: '',
	});

	const helpCadastrarHierarquia = useMemo(
		(): ISidebarHelp => ({
			title: 'Cadastrar Hierarquia',
			firstParagraph:
				'Para cadastrar uma nova hierarquia comercial, entre pelo menos com um Canal de Venda, Zona de Venda e Membro. Os demais campos são opcionais.',
			secondParagraph:
				'Tenha certeza de ter cadastrado previamente os membros em Cadastros > Comercial > Membros.',
			thirdParagraph:
				'Observação: cada membro pode possuir apenas uma zona de venda dentro do seu mercado de atuação. Mas, o mesmo membro pode pertencer a mais de um mercado de atuação!',

			firstLink: URL_CT360,
			secondLink: URL_FALE_CONOSCO,
		}),
		[]
	);

	useEffect(() => {
		setDataSidebar(helpCadastrarHierarquia);
	}, [helpCadastrarHierarquia, setDataSidebar]);

	return (
		<Flex
			direction='column'
			pt={{ sm: '125px', lg: '75px' }}
		>
			<Card px='0px'>
				<FormCadastrarEditarHierarquia
					initialState={formInitialState}
				/>
			</Card>
		</Flex>
	);
}
